<template>
  <v-flex id="scroller" class="scroll-x">
    <v-layout v-scroll:#scroller="onScroll">
      <v-layout wrap>
        <v-flex class="relative" style="position: relative">
          <h4 class="pb-2 opacity-54">{{ title }}</h4>
          <v-flex style="overflow:auto">
            <table class="v-datatable v-table mt-1 my-custom-table on-white-bg"
              :class="{ 'table-min-width': $vuetify.breakpoint.mdAndUp }">
              <tr v-for="(row, i) in rows " :key="i" :class="{ 'd-block': $vuetify.breakpoint.smAndDown }">
                <td :style="$vuetify.breakpoint.smAndDown && 'width:100% !important;'"
                  v-for="(currentField, j) in allFields" :key="j" :class="{ 'd-block': $vuetify.breakpoint.smAndDown }">
                  <component :class="{ 'mr-0': $vuetify.breakpoint.smAndDown, 'mr-1': $vuetify.breakpoint.mdAndUp }"
                    :is="getFieldComponent(currentField)" :field="currentField" :data="row[currentField.name]"
                    :tableName="field.name" :row="i" v-on:update-item="updateRowItem" v-on:blurred="blurredRowItem"
                    embedded :popupCounter="popupCounter" @popupVisible="popupOpened"></component>
                </td>
                <th class="remove-button" v-if="!readonly"
                  :style="$vuetify.breakpoint.smAndDown && 'width:100% !important;'"
                  :class="{ 'd-block': $vuetify.breakpoint.smAndDown, 'remove-max-width': $vuetify.breakpoint.mdAndUp }">
                  <v-btn color="error" icon flat class="mb-4 mx-0 elevation-0 hidden-sm-and-down" :disabled="readonly"
                    @click="removeRow(i)">
                    <v-icon>cancel</v-icon>
                  </v-btn>
                  <v-btn color="error" dark class="mt-0 mb-4 mx-0 elevation-0 hidden-md-and-up" @click="removeRow(i)">
                    <v-icon left>cancel</v-icon>
                    Remove row
                  </v-btn>
                  <v-divider class="mb-4 hidden-md-and-up"></v-divider>
                </th>
              </tr>
            </table>
          </v-flex>
          <v-flex class="mt-0 pt-4" style="overflow:auto">
            <table class="v-datatable v-table mt-1">
              <tr :class="{ 'd-block': $vuetify.breakpoint.smAndDown }">
                <td v-if="!readonly">
                  <v-btn color="secondary" class="mt-0 ml-0 mb-4 mr-0 white--text" @click="newRow()">
                    <v-icon class="mr-2" left dark>add</v-icon>Add new row
                  </v-btn>
                </td>
              </tr>
            </table>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-flex>
</template>

<script>
import RichText from "@/components/cases/case-elements/RichText.vue"
import TextField from "@/components/cases/case-elements/TextField.vue"
import CurrencyField from "@/components/cases/case-elements/CurrencyField.vue"
import NumberField from "@/components/cases/case-elements/NumberField.vue"
import TextArea from "@/components/cases/case-elements/TextArea.vue"
import CheckBox from "@/components/cases/case-elements/CheckBox.vue"
import SelectField from "@/components/cases/case-elements/SelectField.vue"
import BooleanField from "@/components/cases/case-elements/BooleanField.vue"
import AddressField from "@/components/cases/case-elements/AddressField.vue"
import DateField from "@/components/cases/case-elements/DateField.vue"
import RelationField from "@/components/cases/case-elements/RelationField.vue"
import DocumentField from "@/components/cases/case-elements/DocumentField.vue"
import LocationField from "@/components/cases/case-elements/LocationField.vue"
import PasswordField from "@/components/cases/case-elements/PasswordField.vue"
import UrlField from "@/components/cases/case-elements/UrlField.vue"
import CascadingOptionsField from "@/components/cases/case-elements/CascadingOptionsField.vue"
import Helpers from "@/helpers.js"

export default {
  name: "embedded-table",
  props: {
    field: {
      type: Object
    },
    data: {
      type: Array
    },
    popupCounter: {
      type: Number,
      required: false
    }
  },
  components: {
    RichText,
    TextField,
    TextArea,
    CurrencyField,
    NumberField,
    CheckBox,
    SelectField,
    BooleanField,
    AddressField,
    DateField,
    RelationField,
    DocumentField,
    LocationField,
    CascadingOptionsField,
    PasswordField,
    UrlField
  },
  data: () => ({
    offsetLeft: 0
  }),
  computed: {
    title() {
      return this.field.display_name
        ? this.field.display_name
        : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    type() {
      if (this.field.item_type !== undefined) {
        return Helpers.capitalizeRemoveUnderscores(this.field.item_type)
      } else {
        return ""
      }
    },
    rows: {
      get() {
        if (this.data) {
          if (this.data instanceof Array) {
            return this.data
          }
        }
        return []
      },
      set(rows) {
        this.$emit("update-item", { field: this.field.name, data: rows })
      }
    },
    headers() {
      const headers = []
      if (this.field.fields) {
        console.log("FIELDS--------->", this.field.fields)
        this.field.fields.forEach(function (field) {
          if (!field.hidden) {
            headers.push(field.name)
          }
        })
      }
      return headers
    },
    allFields() {
      return (this.field.fields || []).filter(f => !f.hidden)
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) {
        readonly = this.field.readonly
      }
      return readonly
    }
  },
  methods: {
    popupOpened() {
      console.log("popupOpened on embedded")
      this.$emit('popupVisible')
    },
    onScroll(e) {
      this.offsetLeft = e.target.scrollLeft
    },
    newRow() {
      this.$emit("add-new-row-to-table", this.field.name)
    },
    removeRow(index) {
      this.rows.splice(index, 1)
      this.data = this.rows
    },
    updateRowItem({ field, data, row }) {
      if (row !== undefined && this.rows[row]) {
        this.rows[row][field] = data
        this.$emit("update-item", { field, data, row, table: this.field.name })
      } else {
        console.error("Failed to update row", { field, data, row })
      }
    },
    blurredRowItem({ field, row }) {
      this.$emit("blurred", { field, row, table: this.field.name })
    },
    getFieldComponent(field) {
      if (field === undefined) {
        return
      }
      switch (field.type.toLowerCase()) {
        case "email_address":
        case "string":
          switch (field.display) {
            case "text":
              return "TextArea"
            case "richtext":
              return "RichText"
            case "select":
              if (field.cascading_options === null) {
                return "SelectField"
              } else {
                return "CascadingOptionsField"
              }
            case "url":
              return "UrlField"
            default:
              return "TextField"
          }
        case "number":
          if (field.display === "currency") {
            return "CurrencyField"
          } else {
            return "NumberField"
          }
        case "boolean":
          if (field.display === "checkbox") {
            return "CheckBox"
          } else {
            return "BooleanField"
          }
        case "date":
          return "DateField"
        case "relation":
          return "RelationField"
        case "document":
          return "DocumentField"
        case "address":
          return "AddressField"
        case "location":
          return "LocationField"
        case "password":
          return "PasswordField"
        default:
          console.error(
            "EmbeddedTable getFieldComponent - Unknown type! " +
            JSON.stringify(field)
          )
      }
    }
  }
}
</script>
